<template>
  <div class="mt-[20px] px-[24px] kompack-packing-form">
    <div class="grid sm:grid-cols-2 gap-[10px] mb-[24px]">
      <div>
        <p class="text-[#0A0A0A] mb-[12px]">
          Upload Label Pengiriman<span class="text-[#DC2626]">*</span></p>
        <div class="flex items-center justify-start gap-[8px]">
          <b-form-file
            v-model="file1"
            placeholder="Upload label pengiriman"
            drop-placeholder="Taruh label pengiriman di sini..."
            accept="application/pdf"
            :class="[
              '!h-[36px] [&_.custom-file-label]:!rounded-[8px] [&_.custom-file-label]:!border-[#E5E5E5] [&_.custom-file-label]:!text-[14px] [&_.custom-file-label]:!h-[40px] [&_.custom-file-label]:!leading-[38px] [&_.custom-file-label]:!py-0 [&_.custom-file-label]:!px-[16px] [&_.custom-file-label::after]:!bg-[#F5F5F5] [&_.custom-file-label::after]:!text-[#0A0A0A] [&_.custom-file-label::after]:!border-l-[#E5E5E5] [&_.custom-file-label::after]:!border-l [&_.custom-file-label::after]:!rounded-r-[7px] [&_.custom-file-label::after]:!rounded-l-none [&_.custom-file-label::after]:!h-[38px] [&_.custom-file-label::after]:!leading-[38px] [&_.custom-file-label::after]:!py-0 [&_.custom-file-label::after]:!px-[16px]',
              !file1 ? '[&_.custom-file-label]:!text-[#737373]' : '[&_.custom-file-label]:!text-[#0A0A0A]'
            ]"
          />
          <Button
            class="bg-[#F5F5F5] hover:bg-[#E5E5E5] rounded-[8px] text-[#0A0A0A]"
            text-color="#0A0A0A"
            :disabled="!file1"
            @click="handlePreviewPdf"
          >
            Preview
          </Button>
        </div>
      </div>
      <div>
        <p class="text-[#0A0A0A] mb-[12px]">
          Pilih Mitra Gudang<span class="text-[#DC2626]">*</span>
        </p>
        <Select
          v-model="tempWarehouse"
          placeholder="Pilih mitra gudang"
          class="flex-1 bg-white"
          option-label="name"
          :options="warehouseOptions"
          :has-next-page="fetcherWarehouses.hasMore"
          :debounce-timeout="500"
          :loading="fetcherWarehouses.isLoading"
          :clearable="false"
          @on-search="handleSearchWarehouse"
          @on-intersect="fetcherWarehouses.fetchData()"
        >
          <template #no-options="{ search, searching }">
            <template v-if="searching">
              Gudang <em>'{{ search }}'</em> tidak ditemukan.
            </template>
            <em v-else>Masukan nama gudang yang valid</em>
          </template>
        </Select>
      </div>
    </div>
    <div
      class="flex items-center justify-start rounded-[14px] bg-[#EFF6FF] p-[12px] gap-[6px] mb-[24px] flex-wrap"
    >
      <img
        src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
        alt="info-circle"
        width="12px"
        heigh="12px"
      >
      <div class="text-[12px] text-[#0A0A0A]">
        Yuk buat rangkuman ordermu. Kamu hanya perlu input rangkuman
        orderanmu ya dengan cara input jenis isi paket dan jumlah
        ordernya.
        <a
          href="https://www.youtube.com/watch?v=TqIfZ1DMVh4&t"
          target="_blank"
          class="text-[#3B82F6] underline hover:text-[#08A0F7]"
        >Lihat Tutorial</a>
      </div>
    </div>

    <div
      v-for="(packet, index0) in packetType"
      :key="packet.id || index0"
      class="text-[#0A0A0A] border-[1px] border-[#E5E5E5] rounded-[14px] shadow-[0px_1px_0px_0px_#0000000D] mb-[24px]"
    >
      <div class="flex items-center justify-between gap-[10px] flex-wrap border-b-[1px] border-[#E5E5E5] px-[12px] py-[16px]">
        <div class="flex items-center justify-start gap-[10px]">
          <span class="text-[14px] font-medium">
            Jenis Paket {{ index0 + 1 }}
          </span>
          <Button
            v-if="packet.note"
            type="ghost"
            class="!h-auto !min-w-0 px-[10px] py-[2px] rounded-[10px] !text-[12px] transition-colors shadow-[0px_1px_0px_0px_#0000000D]"
            :class="{
              'disabled:opacity-100': true,
              'bg-[#F0FDF4] text-[#22C55E] hover:bg-[#F0FDF4] !cursor-default': packet.note.type === 'success',
              'bg-[#FEFCE8] text-[#EAB308] hover:bg-[#FEFCE8] !cursor-pointer': packet.note.type === 'warning',
              'bg-[#FEF2F2] text-[#DC2626] hover:bg-[#FEF2F2] !cursor-pointer': packet.note.type === 'error',
            }"
            :disabled="packet.note.type === 'success' || packet.saved"
            @click="['warning', 'error'].includes(packet.note.type) && handleInputResi(packet, index0)"
          >
            {{ packet.note.message }}
          </Button>
        </div>
        <div class="flex gap-[12px]">
          <Button
            v-if="packet.saved && index0 === packetType.length - 1 && packetType.length > 1"
            type="icon"
            class="!w-[32px] !h-[32px] hover:!bg-[#FEE2E2]"
            aria-label="Hapus jenis paket"
            :disabled="confirmButton || packetType.length === 1"
            @click="handlePacketRemoval({
              index: index0,
              packet,
              onSaveFn: () => {
                packetType.splice(index0, 1)
                updateProductMap(packet, 'increase')
                if (packetType[0]) syncPacketMaxTotal(packetType[0])
                tellThatPacketIsUpdated()
              }
            })"
          >
            <span class="k-trash text-[#E31A1A] text-[20px]" />
          </Button>
          <Button
            v-if="packet.saved"
            type="ghost"
            class="w-[32px]"
            :disabled="confirmButton"
            @click="handleEditPacket(packet)"
          >
            <span class="k-edit text-[#F95E16] text-[20px]" />
          </Button>
          <Button
            v-if="!packet.saved"
            outline
            :disabled="confirmButton || packetType.length === 1"
            @click="handlePacketRemoval({
              index: index0,
              packet,
              onSaveFn: () => {
                handleLastItemRemoval()
                if (packetType.length === 1) {
                  setOrEmptyPacketType(true)
                } else {
                  packetType.splice(index0, 1)
                  if (packetType[0]) syncPacketMaxTotal(packetType[0])
                }
                tellThatPacketIsUpdated()
              }
            })"
          >
            Hapus
          </Button>
          <Button
            v-if="!packet.saved"
            variant="primary"
            :disabled="packet.isLoading || addPacketContentDisabled(packet) || !packet.total || packet.total > packet.maxTotal || confirmButton"
            @click="handleRecalculation(packet, index0)"
          >
            {{ packet.isLoading ? 'Menyimpan...' : 'Simpan' }}
          </Button>
        </div>
      </div>
      <div class="overflow-x-auto py-[16px] px-[20px] custom-scrollbar">
        <div class="min-w-[990px]">
          <!-- Label -->
          <div class="grid grid-cols-8 text-[#0A0A0A] mb-[12px] gap-[12px]">
            <span class="col-span-2">Isi Paket<span class="text-[#DC2626]">*</span></span>
            <p class="col-span-2 flex items-center justify-start gap-[4px] m-0">
              <span>Variasi<span class="text-[#DC2626]">*</span></span>
              <img
                v-b-tooltip.hover.top="'Variasi tidak dapat dipilih jika stok kosong'"
                src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
                alt="info-circle"
                width="16"
              >
            </p>
            <p class="flex items-center justify-start gap-[4px] m-0">
              <span>Jumlah Item<span class="text-[#DC2626]">*</span></span>
              <img
                v-b-tooltip.hover.top="'Jumlah item produk dalam satu paket'"
                src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
                alt="info-circle"
                width="16"
              >
            </p>
            <p class="flex items-center justify-start gap-[4px] m-0">
              <span>Jumlah Order<span class="text-[#DC2626]">*</span></span>
              <img
                v-b-tooltip.hover.top="'Total jumlah paket dengan isi yang sama'"
                src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
                alt="info-circle"
                width="16"
              >
            </p>
            <span class="col-span-2">Bahan Packing<span class="text-[#DC2626]">*</span></span>
          </div>
          <!-- Fields -->
          <div
            v-for="(item, index1) in packet.packetContent"
            :key="index1"
            class="grid grid-cols-8 text-[#0A0A0A] gap-[12px] mb-[20px]"
          >
            <!-- Isi Paket -->
            <div class="col-span-2">
              <Select
                v-model="item.option"
                placeholder="Pilih Isi Paket"
                class="flex-1 bg-white"
                option-label="label"
                append-to-body
                :calculate-position="positionDropdown"
                :disabled="packet.saved || confirmButton"
                :options="productManagementsData"
                :has-next-page="productManagementsHasMore"
                :filterable="false"
                :debounce-timeout="500"
                :loading="productManagementsLoading"
                :clearable="false"
                @on-search="onSearchProduct"
                @on-intersect="onIntersectProduct"
                @input="updatePacketContent(packet, item)"
              >
                <template #no-options="{ search, searching, loading: isLoadingSlot }">
                  <div
                    v-if="isLoadingSlot || productManagementsLoading"
                    class="text-center flex justify-center items-center gap-[8px] h-[40px] text-[13px] text-[#737373]"
                  >
                    <b-spinner
                      small
                      variant="primary"
                    />
                    <span>Memuat data...</span>
                  </div>
                  <template v-else-if="searching">
                    Produk <em>'{{ search }}'</em> tidak ditemukan.
                  </template>
                  <em v-else>Masukan nama produk yang valid</em>
                </template>
              </Select>

              <Button
                v-if="packet.packetContent.length > 1"
                type="ghost"
                class="text-[#DC2626] my-[12px] px-0"
                :disabled="packet.saved || confirmButton"
                @click="removePacketContent(packet, index1)"
              >
                Hapus Isi Paket
              </Button>
            </div>
            <!-- Variasi -->
            <div class="col-span-2">
              <div v-if="item.option">
                <!-- Product non-bundling -->
                <div v-if="!item.option.is_bundling">
                  <Select
                    v-model="item.variants[0]"
                    :options="item.option.variants"
                    :reduce="option => option"
                    :selectable="checkIsSelectableVariant"
                    :clearable="false"
                    :disabled="packet.saved || confirmButton"
                    :option-label="item.option.is_variant ? 'name' : 'label'"
                    append-to-body
                    :calculate-position="positionDropdown"
                    placeholder="Pilih Variasi"
                    @input="onNonBundlingVariantInput(packet, item)"
                  />
                </div>
                <!-- Product bundling -->
                <div
                  v-if="item.option.is_bundling"
                  class="space-y-5"
                >
                  <div
                    v-for="(bundling, index2) in item.option.variants"
                    :key="index2"
                    class="space-y-5"
                  >
                    <div
                      v-for="qty in bundling.qty"
                      :key="qty"
                    >
                      <Select
                        v-model="item.variants[getBundlingVariantIndex(item.option.variants, index2, qty)]"
                        :options="getBundlingOptions(bundling)"
                        :placeholder="bundling.product_name"
                        :option-label="bundling.bundling_variants && bundling.bundling_variants.length > 0 ? 'name' : 'label'"
                        :disabled="packet.saved || confirmButton"
                        :clearable="false"
                        :selectable="(option) => checkIsSelectableVariant(option, qty)"
                        append-to-body
                        :calculate-position="positionDropdown"
                        @input="onBundlingVariantInput(packet, item, index2, qty)"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <Select
                v-else
                placeholder="Pilih Isi Paket Dulu"
                disabled
              />
            </div>
            <!-- Jumlah Item -->
            <div>
              <UiInput
                v-model.number="item.amount"
                type="number"
                min="1"
                placeholder="Masukkan jumlah item"
                :disabled="packet.saved || !item.option || confirmButton"
                @input="packet.total = null, setMaxAmount(packet, item, item.variants), (item.amount < 1 ? item.amount = 1 : item.amount)"
              />
            </div>
            <!-- Jumlah Order -->
            <div
              v-if="index1 === 0"
            >
              <UiInput
                v-model.number="packet.total"
                type="number"
                min="1"
                :max="packet.maxTotal"
                placeholder="Masukkan jumlah order"
                :disabled="packet.saved || addPacketContentDisabled(packet) || confirmButton"
              />
              <div
                v-if="!packet.saved"
                class="mt-[4px] text-[12px]"
              >
                <span
                  v-b-tooltip.hover.top="'Stok tersedia untuk membuat kombinasi jenis order'"
                  class="text-[#0A0A0A]"
                >Tersedia:</span>
                <span class="font-medium">
                  {{ !addPacketContentDisabled(packet) ? packet.maxTotal : '-' }}
                </span>
              </div>
            </div>
            <!-- Bahan Packing -->
            <div
              v-if="index1 === 0"
              class="col-span-2"
            >
              <PackingSelection
                v-model="packet.packings"
                :fetcher="fetcherPackingMaterials"
                :disabled="addPacketContentDisabled(packet) || packet.saved || confirmButton"
              />

              <Button
                :disabled="addPacketContentDisabled(packet) || packet.saved || confirmButton"
                text-color="primary"
                class="p-0 !h-[20px] text-[14px]"
                type="ghost"
                @click="packet.packings.push({ id: null, name: null, layer: 1 })"
              >
                <span class="k-add text-[14px]" />
                Bahan Packing
              </Button>
            </div>
          </div>
        </div>
      </div>
      <!-- Button tambah isi paket -->
      <div
        class="mx-[16px]"
        :class="isAwbListMode(packet) ? '' : 'mb-[20px]'"
      >
        <Button
          :outline="!isAwbListMode(packet)"
          :class="isAwbListMode(packet) ? 'text-[#F95E16] shadow-none' : ''"
          :disabled="packet.total <= 0"
          @click="handleInputResi(packet, index0, isAwbListMode(packet))"
        >
          {{ isAwbListMode(packet) ? "Lihat No. Resi" : "Input No. Resi" }}
        </Button>
      </div>
      <div class="p-[16px] pt-0">
        <Button
          v-if="!packet.saved"
          class="w-full mt-0"
          :variant="addPacketContentDisabled(packet) ? 'outline-secondary' : 'outline-primary'"
          :disabled="addPacketContentDisabled(packet) || confirmButton"
          @click="pushEmptyPacketContent(packet, index0), packet.total = null"
        >
          Tambah Isi Paket
        </Button>
      </div>
    </div>

    <div class="border-[1px] border-[#E5E5E5] rounded-[14px] p-[16px] mb-[24px]">
      <Button
        variant="primary"
        class="text-[14px]"
        :disabled="somePacketTypeNotSaved() || confirmButton"
        @click="setOrEmptyPacketType(false)"
      >
        Tambah Jenis Paket
      </Button>
    </div>

    <ModalPackingSettings
      ref="modalPackingSettings"
      :fetcher="fetcherPackingMaterials"
      @on-save="handleSavePackingMaterials"
    />
  </div>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'
import filters from '@/libs/filters'
import { Button, Input as UiInput, Select } from '@/@core/components/ui'
import PackingSelection from './PackingSelection.vue'
import ModalPackingSettings from './ModalPackingSettings.vue'
import createRecalculation from '../composables/useRecalculation'
import usePackingMaterialsFetcher from '../composables/usePackingMaterialsFetcher'
import useProductManagements from '../composables/useProductManagements'

export default {
  components: {
    // BulkUploadComponent: () => import('./BulkUploadComponent.vue'),
    ModalPackingSettings,
    Select,
    Button,
    UiInput,
    PackingSelection,
  },
  filters: { rupiah: filters.rupiah },
  props: {
    userData: {
      type: Object,
      default: () => {},
    },
    fetcherWarehouses: {
      type: Object,
      default: () => undefined,
    },
    listWarehouses: {
      type: Object,
      default: () => ({
        isLoading: true,
        isError: false,
        data: [],
      }),
    },
    usedWarehouses: {
      type: Array,
      default: () => [],
    },
    backButton: {
      type: Boolean,
      default: false,
    },
    packings: {
      type: Object,
      default: () => ({
        options: [],
        optionsObj: {},
      }),
    },
    isAllowedForBulkUpload: {
      type: Boolean,
      default: false,
    },
    warehouseIndex: {
      type: Number,
      default: 0,
    },
    modalInputResiRef: {
      type: Object,
      default: () => null,
    },
    modalWarningGeneralRef: {
      type: Object,
      default: () => null,
    },
    checkGlobalDuplicateAwb: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      file1: null,
      confirmButton: true,
      tempWarehouse: null,
      warehouse: null,
      isPacketContentUpdated: false,

      packetContentOption: [],

      packetType: [],

      loading: false,

      file: null,
      rawProductsCache: [],
      bulkDataShown: false,
      isUploadingLabel: false,
      isFetchingProductWarehouse: false,

      fetcher: null,

      packingMaterialsFetcher: null,
      productManagementsFetcher: null,
      lastProductSearch: '',
    }
  },
  computed: {
    packetAwbsMaps() {
      if (!Array.isArray(this.packetType)) return []

      return this.packetType.map(p => {
        const map = {}
        if (Array.isArray(p.awbs)) {
          p.awbs.forEach(awb => {
            if (awb) {
              const trimmed = String(awb).trim()
              if (trimmed) {
                map[trimmed] = true
              }
            }
          })
        }
        return map
      })
    },
    fetcherPackingMaterials() {
      return this.packingMaterialsFetcher?.state?.fetcher
    },
    productManagementsData() {
      return this.productManagementsFetcher?.state?.fetcher?.data || []
    },
    productManagementsHasMore() {
      return this.productManagementsFetcher?.state?.fetcher?.hasMore || false
    },
    productManagementsLoading() {
      const fetcher = this.productManagementsFetcher && this.productManagementsFetcher.state && this.productManagementsFetcher.state.fetcher
      return Boolean(fetcher && fetcher.isLoading && fetcher.offset === 0)
    },
    enableForContentAddition() {
      return this.rawProductsCache.length > 0
          && !this.isFetchingProductWarehouse
          && this.file1
          && this.packings.options.length > 0
    },
    warehouseOptions() {
      const data = this.fetcherWarehouses?.data
      if (!data || !Array.isArray(data)) return []

      const usedWarehousesSet = new Set(this.usedWarehouses)
      const seen = new Set()
      const tempWarehouseName = this.tempWarehouse?.name

      return data.reduce((acc, warehouse) => {
        if (!warehouse) return acc

        const warehouseId = warehouse.id
        if (warehouseId !== undefined && warehouseId !== null) {
          if (seen.has(warehouseId)) {
            return acc
          }
          seen.add(warehouseId)
        }

        acc.push({
          ...warehouse,
          disabled: usedWarehousesSet.has(warehouse.name) && warehouse.name !== tempWarehouseName,
        })
        return acc
      }, [])
    },
    calculatedTotalOrder() {
      return this.packetType.reduce((acc, obj) => {
        const valueToAdd = obj.total !== null && obj.total !== undefined ? obj.total : 0
        return acc + valueToAdd
      }, 0)
    },
    calculatedGrandTotalCost() {
      return this.packetType.reduce((acc, order) => {
        if (order.total_fulfillment_cost) {
          return acc + order.total_fulfillment_cost
        }
        const contentCost = order.packetContent.reduce((acc2, packet) => acc2 + (packet.contentTotalCost || 0), 0)
        return acc + contentCost
      }, 0)
    },
    calculatedGrandKompackRevenue() {
      return this.packetType.reduce((acc, order) => acc + (order?.total_kompack_revenue || 0), 0)
    },
  },
  watch: {
    file1() {
      this.tellThatPacketIsUpdated()
    },
    tempWarehouse: {
      async handler(newValue, oldValue) {
        if (this.isWarehouseReverted) {
          this.isWarehouseReverted = false
          return
        }
        if (newValue === oldValue) return

        if ((this.$refs.bulkUploadComponent && this.$refs.bulkUploadComponent.hasItems) || this.isPacketContentUpdated) {
          await this.handleWarehouseChange(newValue, oldValue)
          return
        }
        this.warehouse = newValue
      },
    },
    warehouse: {
      async handler(newValue, oldValue) {
        if (this.isWarehouseReverted) {
          this.isWarehouseReverted = false
          return
        }
        if (!newValue) return
        try {
          this.$emit('selected-warehouse', newValue)
          this.lastProductSearch = ''
          this.packetContentOption = []
          if (this.productManagementsFetcher?.state?.fetcher) {
            await this.productManagementsFetcher.state.fetcher.fetchData({ reset: true, options: { warehouseId: newValue.id } })
            const productWarehouse = this.productManagementsFetcher.state.fetcher.data
            if (!productWarehouse || productWarehouse.length === 0) {
              this.revertWarehouseSelection(oldValue, newValue)
              return
            }
            this.packetContentOption = productWarehouse
            this.confirmButton = false
            if (this.fetcherPackingMaterials) {
              this.fetcherPackingMaterials.fetchData({ reset: true, options: { warehouseId: newValue.id } })
            }
          }
        } catch (error) {
          this.$toast_error({
            message: 'Gagal mengambil data produk gudang, silahkan coba lagi',
          })
          this.revertWarehouseSelection(oldValue, newValue)
        }
      },
    },
  },
  created() {
    this.packetContentMap = new Map()
    this.kompackCost = undefined
    this.isWarehouseReverted = false
    this.recalculation = createRecalculation(this)
    this.packingMaterialsFetcher = usePackingMaterialsFetcher(this)
    this.productManagementsFetcher = useProductManagements(this)
  },
  mounted() {
    if (this.packingMaterialsFetcher) {
      this.packingMaterialsFetcher.initializeFetcherPackingMaterials()
    }
    if (this.productManagementsFetcher) {
      this.productManagementsFetcher.initializeFetcherProductInWarehouse()
    }
  },
  beforeMount() {
    this.setOrEmptyPacketType(true)
  },
  unmounted() {
    this.packetContentMap.clear()
  },
  methods: {
    isAwbListMode(packet) {
      return packet.saved && packet.total > 0
    },
    handlePreviewPdf() {
      if (this.file1) {
        const fileUrl = URL.createObjectURL(this.file1)
        window.open(fileUrl, '_blank')
      }
    },
    handleSearchWarehouse(query) {
      this.fetcherWarehouses.fetchData({ reset: true, options: { search: query } })
    },
    onSearchProduct(query) {
      const trimmed = (query || '').trim()
      if (this.lastProductSearch === trimmed) {
        return
      }
      this.lastProductSearch = trimmed
      if (this.productManagementsFetcher?.state?.fetcher && this.warehouse?.id) {
        this.productManagementsFetcher.state.fetcher.fetchData({ reset: true, options: { warehouseId: this.warehouse.id, search: trimmed } })
      }
    },
    onIntersectProduct() {
      if (this.productManagementsFetcher?.state?.fetcher) {
        this.productManagementsFetcher.state.fetcher.fetchData()
      }
    },
    /**
     * Reverts the current warehouse selection to the previous value when downstream fetching fails.
     */
    revertWarehouseSelection(previousWarehouse, newWarehouse) {
      this.$emit('revert-warehouse', newWarehouse, previousWarehouse)
      this.isWarehouseReverted = true
      this.tempWarehouse = previousWarehouse
      this.isWarehouseReverted = true
      this.warehouse = previousWarehouse
    },
    /**
     * Ensures the dropdown escapes overflow containers by positioning it relative to the body.
     */
    positionDropdown(dropdownList, component, { width }) {
      const dropdownEl = dropdownList
      dropdownEl.style.width = width
      const {
        top,
        left,
        height,
      } = component.$el.getBoundingClientRect()
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
      dropdownEl.style.left = `${left + scrollLeft}px`
      dropdownEl.style.top = `${top + height + scrollTop}px`
    },
    handleSavePackingMaterials(data) {
      this.packetType[data.position].packings = data.data
    },
    /**
     * Handles the edit packing materials. Summon the modal packing settings to edit the packing materials.
     * @param packet {Object} - The packet object to edit the packing materials.
     * @param position {Number} - The position of the packet to edit the packing materials.
     */
    handleEditPacking(packet, position) {
      const { packings } = packet
      this.$refs.modalPackingSettings.show({
        position,
        packings,
      })
    },
    /**
     * Updates the packet content.
     * @param packetArg {Object} - The packet object to update the content.
     * @param itemArg {Object} - The item object to update the content.
     */
    updatePacketContent(packetArg, itemArg) {
      const packet = packetArg
      const item = itemArg

      if (!item.option) {
        return
      }

      packet.total = null
      item.variants = {}
      item.amount = 1
      if (item.option.is_bundling) {
        item.totalVariant = item.option.variants.reduce((total, product) => total + product.qty, 0)
      } else {
        item.totalVariant = 1
      }
      item.contentTotalCost = 0
      this.isPacketContentUpdated = true
      this.setPacketPackings(packet, item)
      this.syncPacketMaxTotal(packet)
    },
    /**
     * Handles the content is updated.
     */
    handleContentIsUpdated(data) {
      this.$emit('form-is-updated', {
        title: this.warehouse?.name || '',
        warehouse: this.warehouse,
        completed: data.completed,
        totalOrder: data.totalOrder || this.calculatedTotalOrder,
        fulfillmentCost: data.fulfillmentCost || this.calculatedGrandTotalCost,
        somePacketTypeNotSaved: this.somePacketTypeNotSaved(),
      })
      if (data.status === 'shown') {
        this.bulkDataShown = true
      }
    },
    /**
     * Handles the packet change.
     */
    handlePacketChange() {
      this.isPacketContentUpdated = true
    },
    /**
     * Handles the edit packet.
     */
    handleEditPacket(packet) {
      this.$set(packet, 'saved', false)
      this.updateProductMap(packet, 'increase')
      packet.packetContent.forEach(item => {
        if (!item.option || !item.variants) return
        const variantKeys = Object.keys(item.variants)
        if (
          variantKeys.length === item.totalVariant
          && !variantKeys.some(key => item.variants[key] == null)
        ) {
          this.setMaxAmount(packet, item, item.variants, { skipPacketSync: true })
        }
      })
      this.syncPacketMaxTotal(packet)
      this.handleContentIsUpdated({
        completed: false,
      })
    },
    /**
     * Handles the submission of content.
     */
    async handleSubmitContent() {
      if (this.bulkDataShown) {
        if (!this.$refs.bulkUploadComponent) {
          return {
            success: false,
            section: 'submitPacking',
            reason: 'component_not_found',
            payload: {
              outbound_id: null,
              file: null,
            },
          }
        }
        return this.$refs.bulkUploadComponent.handleSubmitBulkUpload(this.file1)
      }
      return this.submitPacking()
    },
    /**
       * Update the available stock for a variant
       *
       * @param {Object} item - The item object containing the variant
       * @param {number} index2 - The index of the bundling
       * @param {number} qty - The quantity of the variant
       * @param {{ skipPacketSync?: boolean }} [options] - When true, caller runs syncPacketMaxTotal after related steps.
       */
    updateAvailable(packet, item, index2, qty, { skipPacketSync = false } = {}) {
      const { variants } = item.option
      const variantIndex = this.getBundlingVariantIndex(variants, index2, qty)
      const lastVariant = item.variants[variantIndex]
      if (!lastVariant) return

      const lastData = this.packetContentMap.get(`${lastVariant.product_id}&${lastVariant.id}`)
      const variant = !lastData ? lastVariant : {
        ...lastVariant,
        qty,
        available: lastData.available,
        usedStock: lastData.usedStock,
      }

      if (lastData) {
        this.$set(item.variants, variantIndex, variant)
      }

      this.setMaxAmount(packet, item, item.variants, { skipPacketSync })
    },
    /**
     * Non-bundling: collapse duplicate lines first, then recompute availability for this row.
     * Order matches legacy chained @input (removeSameVariant → updateAvailable); one sync at end.
     */
    onNonBundlingVariantInput(packet, item) {
      this.removeSameVariant(packet, { skipPacketSync: true })
      this.updateAvailable(packet, item, 0, item.amount, { skipPacketSync: true })
      this.syncPacketMaxTotal(packet)
    },
    /**
     * Bundling: merge variant from packet map first, then dedupe lines.
     * Order matches legacy chained @input (updateAvailable → removeSameVariant); one sync at end.
     */
    onBundlingVariantInput(packet, item, index2, qty) {
      this.updateAvailable(packet, item, index2, qty, { skipPacketSync: true })
      this.removeSameVariant(packet, { skipPacketSync: true })
      this.syncPacketMaxTotal(packet)
    },
    /**
       * Calculate the correct variant index for bundling products
       * This fixes the bug where qty > 6 causes wrong variant selection
       *
       * @param {Array} variants - Array of all bundling variants
       * @param {number} bundlingIndex - Current bundling index (index2)
       * @param {number} qtyIndex - Current quantity index (qty)
       * @returns {number} Correct variant index
       */
    getBundlingVariantIndex(variants, bundlingIndex, qtyIndex) {
      let cumulativeIndex = 0

      // Sum up quantities of all previous bundlings
      for (let i = 0; i < bundlingIndex; i += 1) {
        cumulativeIndex += variants[i].qty
      }

      // Add current quantity index (minus 1 because qty starts from 1)
      cumulativeIndex += qtyIndex - 1

      return cumulativeIndex
    },
    getBundlingOptions(bundling) {
      if (bundling.bundling_variants && bundling.bundling_variants.length > 0) {
        return bundling.bundling_variants
      }
      return [{
        id: 0,
        product_id: bundling.product_id,
        name: bundling.product_name,
        stock: bundling.stock,
        qty: bundling.qty,
        label: `${bundling.product_name} : -`,
        is_product_bonus: bundling.is_product_bonus,
      }]
    },
    async doRecalculate({ packet, index }) {
      const currentPacket = packet
      currentPacket.isLoading = true
      const result = await this.recalculation.recalculateFulfillment(packet)
      if (result.success) {
        currentPacket.total_fulfillment_cost = result.data.grand_fulfillment_cost
        currentPacket.fulfillment_cost = result.data.fulfillment_cost
        currentPacket.total_kompack_revenue = result.data.grand_kompack_revenue
        currentPacket.storage_cost = result.data.storage_cost
        currentPacket.packing_cost = result.data.packing_cost
        currentPacket.saved = true
        currentPacket.order = index + 1
        this.kompackCost = result.data.kompack_revenue
        this.updateProductMap(currentPacket, 'reduce')
        this.handleContentIsUpdated({
          completed: this.warehouse && this.file1 && !this.somePacketTypeNotSaved(),
        })
      }
      currentPacket.isLoading = false
    },
    async handleRecalculation(packet, index) {
      let awbsValidationResult = {}
      if (!packet.note) {
        if (this.modalInputResiRef) {
          this.modalInputResiRef.data = packet || {}
          const targetTotal = Number(packet.total) || 1
          const existingAwbs = Array.isArray(packet.awbs) ? packet.awbs : []
          this.modalInputResiRef.awbs = Array.from({ length: targetTotal }, (_, i) => existingAwbs[i] || '')
          this.modalInputResiRef.currentWarehouseIndex = this.warehouseIndex
          this.modalInputResiRef.currentPacketIndex = index
          this.modalInputResiRef.checkDuplicateFn = awb => (
            this.checkGlobalDuplicateAwb ? this.checkGlobalDuplicateAwb(awb, this.warehouseIndex, index) : false
          )

          const message = await this.modalInputResiRef.validate()
          this.$set(this.packetType[index], 'awbs', this.modalInputResiRef.awbs)
          this.$set(this.packetType[index], 'note', message)

          awbsValidationResult = { ...message }
        }
      }

      if ([packet.note.type, awbsValidationResult.type].includes('error')) {
        this.$toast_error({
          message: 'Harap perbaiki nomor resi terlebih dahulu',
        })
        if (this.modalWarningGeneralRef) {
          this.modalWarningGeneralRef.show({
            title: 'Nomor Resi Ganda',
            description: 'Kamu memiliki nomor resi yang ganda atau double, Harap input kembali dengan nomor resi yang sesuai',

            saveBtn: {
              label: 'Edit',
              variant: 'ghost',
              outline: true,
            },
            hideCancel: true,
            onSaveFn: () => {
              if (this.modalInputResiRef) {
                this.modalInputResiRef.show({
                  data: packet || {},
                  onSaveFn: ({ awbs, data, message }) => {
                    this.$set(packet, 'awbs', awbs)
                    this.$set(packet, 'note', message)
                    this.handleRecalculation(packet, index)
                  },
                })
              }
            },
          })
        }
        return
      }

      if ([packet.note.type, awbsValidationResult.type].includes('warning') && [packet.note.message, awbsValidationResult.message].includes('No. Resi Belum Diisi')) {
        this.modalWarningGeneralRef.show({
          title: 'Resi Belum Diisi',
          description: 'Ada paket dengan resi yang belum diisi. Sistem tidak bisa membantu deteksi input resi ganda. Lanjutkan?',

          saveBtn: {
            label: 'Lanjutkan',
            variant: 'primary',
            outline: false,
          },
          onSaveFn: async () => {
            await this.doRecalculate({ packet, index })
          },
        })

        return
      }

      await this.doRecalculate({ packet, index })
    },
    /**
     * Tell that the packet is updated to parent component.
     */
    tellThatPacketIsUpdated() {
      this.handleContentIsUpdated({
        completed: this.warehouse && this.file1 && !this.somePacketTypeNotSaved(),
      })
    },
    /**
       * Sets the packings field for a given packet and remove duplicate packing material.
       *
       * @param {Object} packet - The packet object to set packings for.
       */
    setPacketPackings(packet, item) {
      const currentPacket = packet

      const mappedPackings = currentPacket.packetContent.reduce(
        (acc, content) => {
          (content.option?.packings || []).forEach(packing => {
            const packingId = packing.id
            if (acc.indexMap.has(packingId)) {
              const existingIndex = acc.indexMap.get(packingId)
              acc.packings[existingIndex].layer = 1
            } else {
              acc.packings.push({ ...packing })
              const newIndex = acc.packings.length - 1
              acc.indexMap.set(packingId, newIndex)
            }
          })
          return acc
        },
        { packings: [], indexMap: new Map() },
      )

      currentPacket.packings = mappedPackings.packings
    },
    /**
     * @param {{ skipPacketSync?: boolean }} [options] - When true, caller runs syncPacketMaxTotal after related steps.
     */
    removeSameVariant(packet, { skipPacketSync = false } = {}) {
      const items = packet.packetContent
      const uniqueItems = []
      const seen = new Set()

      items.forEach(item => {
        const { amount, ...itemWithoutAmount } = item
        const identifier = Object.values(itemWithoutAmount.variants).map(variant => `${variant.product_id}&${variant.id}`).join(',')
        if (!seen.has(identifier)) {
          seen.add(identifier)
          uniqueItems.push(item)
        }
      })

      // eslint-disable-next-line no-param-reassign
      items.length = 0
      uniqueItems.forEach(item => { items.push(item) })
      if (!skipPacketSync) this.syncPacketMaxTotal(packet)
    },
    previewFile() {
      const reader = new FileReader()

      reader.onload = e => {
        const pdfData = e.target.result

        const newTab = window.open()
        newTab.document.body.innerHTML = `<embed width="100%" height="100%" src="${pdfData}" type="application/pdf" />`
      }

      reader.readAsDataURL(this.file1)
    },
    formatNumber(value) {
      return value ? value.replace(/[^\d]/g, '').slice(0, 7) : value
    },
    setOrEmptyPacketType(set) {
      const createEmptyPacket = () => ({
        id: Date.now() + Math.random(),
        order: null,
        total: null,
        packetContent: [
          {
            amount: null,
            option: null,
            totalVariant: 0,
            contentTotalCost: 0,
            product_variant_id: 0,
            variants: {},
          },
        ],
        saved: false,
        maxTotal: 0,
        total_fulfillment_cost: 0,
        packings: [],
        isLoading: false,
      })

      this.packetType = set ? [createEmptyPacket()] : [...this.packetType, createEmptyPacket()]
      this.tellThatPacketIsUpdated()
    },
    pushEmptyPacketContent(packet, index) {
      packet.packetContent.push({
        amount: null,
        option: null,
        totalVariant: 0,
        contentTotalCost: 0,
        product_variant_id: 0,
        variants: {},
      })
      this.syncPacketMaxTotal(packet)
    },
    addPacketContentDisabled(packet) {
      return packet.packetContent.some(item => !item.variants
        || !item.amount
        || item.amount === ''
        || Object.keys(item.variants).some(key => item.variants[key] === null)
        || Object.keys(item.variants).length !== item.totalVariant) || !packet.packings
    },
    editPackagingDisabled(packet) {
      return packet.saved
        || !packet.total
        || this.confirmButton
        || this.addPacketContentDisabled(packet)
    },
    somePacketTypeNotSaved() {
      return this.packetType.some(packet => !packet.saved)
    },
    async submitPacking() {
      this.loading = true
      const mappedPackages = this.packetType.map((item, index) => ({
        order_list: item.order,
        total_order: item.total,
        fulfillment_fee: item.fulfillment_cost,
        kompack_revenue: item.total_kompack_revenue,
        storage_cost: item.storage_cost,
        packing_cost: item.packing_cost,
        packings: item.packings,
        awbs: (item.awbs || []).map(awb => ({
          awb,
        })),
        products: item.packetContent.map(packet => {
          const product = {
            total_item: packet.amount,
            product_id: packet.option.value,
            product_name: packet.option.label,
            product_variant_id: 0,
            variant_name: '',
            is_bundling: packet.option.is_bundling,
            product_bundles: [],
            product_fulfillment: packet.option.fulfillment_cost,
            is_product_bonus: packet.option.is_product_bonus,
          }

          if (packet.option.is_bundling) {
            product.product_variant_id = 0
            product.variant_name = ''
            product.product_bundles = Object.values(packet.variants).map(variant => ({
              product_id: variant.product_id,
              product_name: variant.name.split(' : ')[0],
              product_variant_id: variant.id,
              variant_name: variant.name,
              qty: 1,
              is_product_bonus: variant.is_product_bonus,
            }))
          } else {
            product.product_variant_id = packet.option.is_variant ? packet.variants[0].id : 0
            product.variant_name = packet.option.is_variant ? packet.variants[0].name : ''
          }

          return product
        }),
      }))

      const { mitra_id, id: warehouse_id } = this.warehouse

      const payload = {
        kompack_tech_cost: this.kompackCost,
        grand_kompack_revenue: this.calculatedGrandKompackRevenue,
        grand_fulfillment_fee: this.calculatedGrandTotalCost,
        grand_total_order: this.calculatedTotalOrder,
        mitra_id,
        packages: mappedPackages,
        warehouse_id,
      }

      try {
        const { data } = await newAxiosIns.post('/kompack/api/v1/outbounds', payload)
        if (data.meta.code === 201) {
          return {
            success: true,
            section: 'submitPacking',
            payload: {
              outbound_id: data.data.outbound_id,
              file: this.file1,
            },
          }
        }
      } catch (error) {
        if (error.response.data.meta && error.response.data.meta.message === 'insufficient user balance') {
          return {
            success: false,
            section: 'submitPacking',
            reason: 'insufficient_balance',
            payload: {
              outbound_id: null,
              file: null,
            },
          }
        }
        return {
          success: false,
          section: 'submitPacking',
          reason: 'failed_to_submit',
          payload: {
            outbound_id: null,
            file: null,
          },
        }
      } finally {
        this.loading = false
      }

      return {
        success: false,
        section: 'submitPacking',
        reason: 'failed_to_submit',
        payload: {
          outbound_id: null,
          file: null,
        },
      }
    },
    handleBulkDataSuccess(bulkDataSubmitResponse) {
      const { outbound_id } = bulkDataSubmitResponse.data
      this.isUploadingLabel = true
      const formData = new FormData()
      formData.append('label', this.file1)

      newAxiosIns.put(`/kompack/api/v1/outbounds/${outbound_id}/label`, formData)
        .then(() => {
          this.$swal({
            title: 'Pengajuan Packing Berhasil',
            text: 'Pengajuan packing akan segera diproses oleh mitra gudang',
            icon: 'success',
            iconHtml: '<img src="https://storage.googleapis.com/komerce/core/icon-popup-success.png">',
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: 'Selesai',
            customClass: {
              icon: 'border-0 mb-[16px]',
              confirmButton: 'btn btn-primary w-full',
            },
            buttonsStyling: false,
          }).then(result => {
            if (result.value) {
              this.$router.push({
                path: '/history-pickup',
              })
            }
          })
        })
        .catch(err => {
          this.$toast.error('Pengajuan packing gagal diajukan')
        })
        .finally(() => {
          this.isUploadingLabel = false
        })
    },
    async handleWarehouseChange(newValue, oldValue) {
      await this.$nextTick()
      const popup = await this.$swal({
        title: 'Konfirmasi Ubah Gudang',
        html: '<span class="text-[#626262]">Data orderan yang sudah diinput akan hilang jika kamu ganti gudang. Tetap ubah pilihan gudang?</span>',
        icon: 'warning',
        iconHtml: '<img src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png">',
        showCancelButton: true,
        showConfirmButton: true,
        cancelButtonText: 'Batal',
        confirmButtonText: 'Ubah Gudang',
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
          popup: '!max-w-[620px] !w-full text-[#626262]',
          title: 'mb-1',
          icon: 'border-0 mb-[16px] size-[92px]',
          actions: 'flex flex-row flex-wrap gap-2',
          confirmButton: 'btn btn-primary grow',
          cancelButton: 'btn btn-outline-primary grow',
        },
        buttonsStyling: false,
      })

      if (popup.isConfirmed) {
        if (this.$refs.bulkUploadComponent) {
          this.$refs.bulkUploadComponent.handleDeleteAll()
        }
        this.setOrEmptyPacketType(true)
        this.warehouse = newValue
        this.packetContentMap.clear()
        return
      }

      this.isWarehouseReverted = true
      this.tempWarehouse = oldValue
    },
    /**
     * Check if the variant is selectable based on stock and used stock
     * @param option {Object} - The option object
     * @param qty {number} - The quantity
     * @returns {boolean} - Whether the variant is selectable
     */
    checkIsSelectableVariant(option, qty = 0) {
      const lastData = this.packetContentMap.get(`${option.product_id}&${option.id}`)
      const stock = lastData?.stock || option.stock
      const usedStock = lastData?.usedStock || option.usedStock || 0
      return (stock - usedStock) / qty >= 1
    },
    /**
     * Update the product map so we can use it to check if the stock is enough based on last operation
     * @param packet {Object} - The packet object
     * @returns {void}
     */
    updateProductMap(packet, type) {
      packet.packetContent.forEach(item => {
        Object.values(item.variants).forEach(variant => {
          const usedStock = (variant.qty || 1) * (item.amount || 1) * (packet.total || 0)
          const newVariantData = {
            ...variant,
            available: item.available,
            usedStock: type === 'reduce' ? (variant.usedStock || 0) + usedStock : (variant.usedStock || 0),
          }
          this.packetContentMap.set(`${variant.product_id}&${variant.id}`, newVariantData)
        })
      })
    },
    /**
     * Max order (packet.total) is limited by the scarcest product line in the packet.
     * @param packet {Object}
     */
    syncPacketMaxTotal(packet) {
      const completeItems = packet.packetContent.filter(item => {
        if (!item.option || !item.variants || item.amount < 1) return false
        const variantList = Object.keys(item.variants)
        return (
          variantList.length > 0
          && variantList.length === item.totalVariant
          && !variantList.some(key => item.variants[key] == null)
        )
      })

      if (!completeItems.length) {
        this.$set(packet, 'maxTotal', 0)
        return
      }

      const limits = completeItems
        .map(item => item.available)
        .filter(av => typeof av === 'number' && Number.isFinite(av))

      const maxTotal = limits.length ? Math.min(...limits) : 0
      this.$set(packet, 'maxTotal', maxTotal)
      if (packet.total != null && maxTotal > 0 && packet.total > maxTotal) {
        this.$set(packet, 'total', maxTotal)
      }
    },
    /**
     * Set the maximum order count allowed for this line item (per-product), then sync packet.maxTotal.
     * @param packet {Object} - The packet containing all product lines
     * @param item {Object} - The item object
     * @param variants {Object} - The variants map
     * @param {{ skipPacketSync?: boolean }} [options] - When skipPacketSync, caller must run syncPacketMaxTotal(packet) after batch updates.
     * @returns {void}
     */
    setMaxAmount(packet, item, variants, { skipPacketSync = false } = {}) {
      const variantList = Object.values(variants || {})
      if (!variantList.length) {
        this.$set(item, 'available', 0)
        if (!skipPacketSync) this.syncPacketMaxTotal(packet)
        return
      }

      const availableItems = variantList.map(variant => (
        ((variant.stock - (variant.usedStock || 0)) / (item.amount || 1)) / (variant.qty || 1)
      ))
      const minAvailable = Math.min(...availableItems)
      const available = Number.isFinite(minAvailable) ? Math.floor(minAvailable) : 0

      this.$set(item, 'available', available)
      if (!skipPacketSync) this.syncPacketMaxTotal(packet)
    },
    /**
     * Handle the last item removal to clear the packet content map
     */
    handleLastItemRemoval() {
      if (this.packetType.length === 1) {
        this.packetContentMap.clear()
      }
    },
    /**
     * Remove an item from the packet content
     * @param packet {Object} - The packet object
     * @param index {number} [index] - The index of the item to remove
     */
    removePacketContent(packet, index) {
      if (!packet || !packet.packetContent || packet.packetContent.length <= 1) return
      const itemIndex = typeof index === 'number' ? index : packet.packetContent.length - 1
      packet.packetContent.splice(itemIndex, 1)
      this.$set(packet, 'total', null)
      this.setPacketPackings(packet)
      this.syncPacketMaxTotal(packet)
      this.tellThatPacketIsUpdated()
    },
    handleInputResi(packet, index, listMode) {
      if (this.modalInputResiRef) {
        this.modalInputResiRef.show({
          data: packet,
          listMode,
          currentWarehouseIndex: this.warehouseIndex,
          currentPacketIndex: index,
          checkDuplicateFn: awb => (
            this.checkGlobalDuplicateAwb ? this.checkGlobalDuplicateAwb(awb, this.warehouseIndex, index) : false
          ),
          onSaveFn: ({ awbs, message }) => {
            this.$set(this.packetType[index], 'awbs', awbs)
            this.$set(this.packetType[index], 'note', message)
          },
        })
      }
    },
    checkAwbExists(awb, excludePacketIndex = -1) {
      if (!this.packetAwbsMaps || !Array.isArray(this.packetAwbsMaps)) return false

      for (let pIndex = 0; pIndex < this.packetAwbsMaps.length; pIndex += 1) {
        if (pIndex !== excludePacketIndex) {
          const map = this.packetAwbsMaps[pIndex]
          if (map && map[awb]) {
            return { packetIndex: pIndex }
          }
        }
      }
      return false
    },
    handlePacketRemoval(options = {}) {
      const packetIndex = typeof options.index === 'number' ? options.index : (options.data?.index || 0)
      if (this.modalWarningGeneralRef) {
        this.modalWarningGeneralRef.show({
          title: 'Hapus Jenis Paket',
          description: `Apakah kamu yakin untuk menghapus jenis paket ${packetIndex + 1}?`,
          onSaveFn: () => {
            if (typeof options.onSaveFn === 'function') {
              options.onSaveFn()
            } else {
              if (this.packetType.length === 1) {
                this.setOrEmptyPacketType(true)
              } else {
                this.packetType.splice(packetIndex, 1)
                if (this.packetType[0]) {
                  this.syncPacketMaxTotal(this.packetType[0])
                }
              }
              this.tellThatPacketIsUpdated()
            }
          },
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@core/components/ui/table/scrollbar.scss';
</style>
